import { createStoreCreator } from 'lib/store'
import reducer from 'reports/dashboard/reducers'

export default createStoreCreator(reducer)
